export const reviews: Array<[string, string, string, string, string]> = [
  [
    'MG',
    'María G.',
    'Docente de Seguridad e Higiene · Buenos Aires',
    'En una tarde tenía más material sobre prevención y riesgos laborales contextualizado en Argentina que en toda mi carrera profesional. Ahora mis alumnos y colegas me preguntan sobre identificación de peligros, evaluación de riesgos, máquinas, electricidad, incendios y EPP, y tengo respuesta fundamentada para todo. El impacto es visible desde la primera semana.',
    'bg-navy',
  ],
  [
    'RT',
    'Rodrigo T.',
    'Instructor de Talleres · Santa Cruz',
    'Mis estudiantes por primera vez entendieron la diferencia entre peligro y riesgo, y analizaron casos reales de accidentes laborales en Argentina con marcos normativos vigentes. El nivel de participación en las clases se multiplicó y empezaron a ver la prevención como responsabilidad real, no como teoría abstracta.',
    'bg-navyDeep',
  ],
  [
    'SP',
    'Sandra P.',
    'Coordinadora de Seguridad e Higiene · Córdoba',
    'Las simulaciones de identificación de riesgos con las plantillas del MEGAPACK son exactamente lo que necesitaba: checklists reales, organismos argentinos, normativas vigentes, casos de empresas argentinas, estrategias de prevención aplicables. Cambió la forma en que planifico todo el año.',
    'bg-navySoft',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'FM',
    'Federico M.',
    'Buenos Aires · Megapack Seguridad e Higiene',
    'Con el MEGAPACK, en una tarde tenía el marco conceptual completo para explicar por qué la prevención es importante, qué normativa argentina regula la seguridad laboral, y por qué cada medida de protección existe porque alguien decidió que la vida de los trabajadores es fundamental. Mis alumnos empezaron a ver la prevención como una responsabilidad real. Porque lo es.',
  ],
  [
    'RV',
    'Rosa V.',
    'Neuquén · Megapack Seguridad e Higiene',
    'Cuando explicás que la seguridad no es solo cumplir reglas, sino proteger vidas, que Argentina tiene normas específicas que regulan cada riesgo, que identificar peligros es una competencia profesional, empieza un debate sobre responsabilidad y derechos laborales que ninguna otra asignatura genera con esa profundidad.',
  ],
  [
    'GN',
    'Gabriela N.',
    'Santa Cruz · Megapack Seguridad e Higiene',
    'Cuando mis alumnos descubren que Argentina tiene empresas que están transformando la cultura de prevención, que existen espacios donde la seguridad es prioridad, que la identificación de riesgos puede prevenir tragedias, que ser un prevencionista es una responsabilidad real, empieza una conversación sobre el valor de proteger la vida que ningún libro de texto puede provocar.',
  ],
  [
    'AS',
    'Alejandro S.',
    'Río Negro · Megapack Seguridad e Higiene',
    'Cerré mi planificación anual de Seguridad e Higiene en dos horas. Antes me llevaba semanas. Ahora tengo todo el año organizado con normativas actualizadas, 100 casos para analizar, 150 actividades listas, 50 checklists para usar, 100 láminas para proyectar y evaluación integrada.',
  ],
  [
    'SM',
    'Sofía M.',
    'Mendoza · Megapack Seguridad e Higiene',
    'Cuando les digo a mis alumnos que el prevencionista que trabaja en una pequeña empresa de La Rioja está haciendo lo mismo que los especialistas en seguridad de las grandes corporaciones: detectando riesgos, recomendando controles, investigando incidentes, capacitando, protegiendo vidas y siendo la voz de la prevención en el lugar de trabajo, les estoy enseñando lo que significa ser un profesional responsable en el mundo real.',
  ],
];
